<template>
  <v-menu v-model="menu">
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="stockDistrictSelected"
        :clearable="!unclearable"
        :items="stockDistrictsSelected"
        :loading="stockDistrictsLoading"
        :search-input.sync="stockDistrictsSearch"
        item-text="name"
        item-value="id"
        :label="noLabel ? '' : $t('StockDistrict.title')"
        :error-messages="errorMessages"
        return-object
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="tree"
          :items="stockDistricts"
          :search="stockDistrictsSearch"
          :filter="districtsFilter"
          :active.sync="stockDistrictsSelected"
          item-key="id"
          item-children="stock_districts"
          open-all
          hoverable
          activatable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import StockDistricts from "@/api/stock_districts";

export default {
  name: "SearcherStockDistrict",

  props: {
    value: Object,
    noLabel: Boolean,
    unclearable: Boolean,
    errorMessages: Array,
  },

  computed: {
    districtsFilter() {
      return (item, search, textKey) =>
        this.stockDistrictSelected && search == this.stockDistrictSelected.name
          ? true
          : item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getStockDistrictsFromAPI();
  },

  data: () => ({
    menu: false,
    tree: [],
    stockDistricts: [],
    stockDistrictsLoading: false,
    stockDistrictsSearch: "",
    stockDistrictsSelected: [],
    stockDistrictSelected: null,
  }),

  methods: {
    getStockDistrictsFromAPI() {
      this.stockDistrictsLoading = true;
      StockDistricts.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stockDistricts = response.data.stock_districts;
              if (this.$route.query.stock_district_id) {
                this.stockDistrictSelected = this.$commonUtils.breadthQuery(
                  this.stockDistricts,
                  this.$route.query.stock_district_id,
                  "stock_districts"
                );
              }
            }
            this.stockDistrictsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.stockDistrictsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockDistrictsSelected = this.value ? [this.value] : [];
      },
    },
    stockDistrictsSelected: {
      handler() {
        this.stockDistrictSelected =
          this.stockDistrictsSelected && this.stockDistrictsSelected[0]
            ? this.stockDistrictsSelected[0]
            : null;
      },
    },
    stockDistrictSelected: {
      handler() {
        this.stockDistrictsSelected = this.stockDistrictSelected
          ? [this.stockDistrictSelected]
          : [];
        this.$emit("input", this.stockDistrictSelected);
      },
    },
    stockDistrictsSearch: {
      handler() {
        if (!this.unclearable && !this.stockDistrictsSearch)
          this.stockDistrictsSelected = [];
      },
    },
  },
};
</script>
